<template>
  <apexchart :options="options" :series="series"></apexchart>
</template> 

<script>
import VueApexCharts from "vue3-apexcharts";
import { useViewSelector } from "../../stores/viewSelector";
import { storeToRefs } from 'pinia';
import { useUserStore } from '../../stores/user';
export default{
  name: 'aiDailyPredChart',
  components:{
    apexchart: VueApexCharts,
  },
  setup() {
    const viewSelector = useViewSelector();
    const {currentView} = storeToRefs(viewSelector);

    const userStore = useUserStore();
    const {analysis, isSessionExpired} = storeToRefs(userStore);
    const { trigSessVerify } = userStore;

    return {
      currentView,
      analysis,
      isSessionExpired,
      trigSessVerify,
    }
  },
  data(){
    return {
      options: {
        chart: {
          type:'line',
          id: 'aiDailyPredChart',
          width:'100%',
        },
        xaxis: {
          type:'datetime',
          categories:[],
        },
        yaxis: {
          labels: {
            formatter: val => val.toFixed()
          }
        },
        dataLabels:{
          enabled:false,
        },
        title: {
          text: "Daily Predictions",
        },
        noData:{
          text: 'No predictions have been run yet.',
          align: 'center',
          verticalAlign: 'bottom',
          offsetX: 0,
          offsetY: 28,
          style: {
            color: '#01009F',
            fontSize: '14px',
            fontFamily: 'Montserrat'
          }
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                toolbar: {
                  tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                  }
                },
              },
            }
          }
        ]
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
        },
      },
      legend: {
        position: 'right',
        offsetY: 40,
      },
      series: [{
            name: 'Daily Predictions',
            data: []
          },
      ],
    }
  },  
  
  mounted() {
    let url = process.env.VUE_APP_URL + '/aiDailyPredReq';

    let nB = {'a_id': this.analysis}
    this.trigSessVerify()
    fetch(url, {
      method:'POST',
      body:JSON.stringify(nB),
      headers: new Headers({
        "content-type":"application/json"
      })
    })
    .then((res) =>res.json())
    .then((content) => {
      console.log(content);
      if(content.invalidSession){
        this.isSessionExpired = true;
      }else{
        let x = content.map(({cal_date})=>cal_date);
        let y = content.map(({preds})=>preds);
        this.options = {
        ...this.options,
        ...{
            xaxis:{
              categories: x
            }
          }
        }
        this.series[0].data = y;
      }
    })
    .catch((err) => {console.log('Erro, '+err)}); 
    
  },
}
</script>


<style>
</style>
